module.exports = __webpack_public_path__ + "img/menu-btn.77529d5f.svg";